import { mediaMax } from "components/designV2/breakpoints";
import { Spacing } from "components/designV2/constants";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled from "styled-components";

export const AlertModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.lg}px;
`;

export const AlertModalMessage = styled.div`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue2};
  white-space: pre-wrap;
`;

export const AlertModalActions = styled.div`
  display: flex;
  gap: ${Spacing.sm}px;
  justify-content: flex-end;

  ${mediaMax.mobile} {
    align-items: stretch;
    flex-direction: column-reverse;
  }
`;

export const DuplicateDatesContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.lg}px;
`;

export const DuplicateDatesLead = styled.div`
  ${TypographyV2.b1}
  color: ${ColorV2.Blue1};
`;

export const DuplicateDatesList = styled.div`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue2};
  line-height: 1.5;
  word-break: break-word;
`;

export const DuplicateDatesDescription = styled.div`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue4};
  line-height: 1.5;
`;
